const a = "Afghanistan", e = "Albania", n = "Algeria", i = "Andorra", o = "Angola", r = "Anguilla", t = "Antarctica", c = "Argentina", s = "Armenia", d = "Aruba", u = "Australia", g = "Austria", l = "Azerbaijan", m = "Bahamas", b = "Bahrain", h = "Bangladesh", S = "Barbados", p = "Belarus", A = "Belgium", $ = "Belize", I = "Benin", y = "Bermuda", M = "Bhutan", C = "Botswana", B = "Brazil", E = "Bulgaria", O = "Burundi", G = "Cambodia", N = "Cameroon", T = "Canada", L = "Chad", f = "Chile", P = "China", _ = "Colombia", R = "Comoros", k = "Congo", K = "Croatia", v = "Cuba", U = "Cyprus", z = "Czechia", F = "Denmark", w = "Djibouti", D = "Dominica", H = "Ecuador", V = "Egypt", W = "Eritrea", Z = "Estonia", J = "Eswatini", j = "Ethiopia", q = "Fiji", x = "Finland", Y = "France", Q = "Gabon", X = "Gambia", aa = "Georgia", ea = "Germany", na = "Ghana", ia = "Gibraltar", oa = "Greece", ra = "Greenland", ta = "Grenada", ca = "Guadeloupe", sa = "Guam", da = "Guatemala", ua = "Guernsey", ga = "Guinea", la = "Guyana", ma = "Haiti", ba = "Honduras", ha = "Hungary", Sa = "Iceland", pa = "India", Aa = "Indonesia", $a = "Iraq", Ia = "Ireland", ya = "Israel", Ma = "Italy", Ca = "Jamaica", Ba = "Japan", Ea = "Jersey", Oa = "Jordan", Ga = "Kazakhstan", Na = "Kenya", Ta = "Kiribati", La = "Kuwait", fa = "Kyrgyzstan", Pa = "Latvia", _a = "Lebanon", Ra = "Lesotho", ka = "Liberia", Ka = "Libya", va = "Liechtenstein", Ua = "Lithuania", za = "Luxembourg", Fa = "Macao", wa = "Madagascar", Da = "Malawi", Ha = "Malaysia", Va = "Maldives", Wa = "Mali", Za = "Malta", Ja = "Martinique", ja = "Mauritania", qa = "Mauritius", xa = "Mayotte", Ya = "Mexico", Qa = "Monaco", Xa = "Mongolia", ae = "Montenegro", ee = "Montserrat", ne = "Morocco", ie = "Mozambique", oe = "Myanmar", re = "Namibia", te = "Nauru", ce = "Nepal", se = "Netherlands", de = "Nicaragua", ue = "Niger", ge = "Nigeria", le = "Niue", me = "Norway", be = "Oman", he = "Pakistan", Se = "Palau", pe = "Panama", Ae = "Paraguay", $e = "Peru", Ie = "Philippines", ye = "Pitcairn", Me = "Poland", Ce = "Portugal", Be = "Qatar", Ee = "Romania", Oe = "Rwanda", Ge = "Samoa", Ne = "Senegal", Te = "Serbia", Le = "Seychelles", fe = "Singapore", Pe = "Slovakia", _e = "Slovenia", Re = "Somalia", ke = "Spain", Ke = "Sudan", ve = "Suriname", Ue = "Sweden", ze = "Switzerland", Fe = "Tajikistan", we = "Thailand", De = "Togo", He = "Tokelau", Ve = "Tonga", We = "Tunisia", Ze = "Turkey", Je = "Turkmenistan", je = "Tuvalu", qe = "Uganda", xe = "Ukraine", Ye = "Uruguay", Qe = "Uzbekistan", Xe = "Vanuatu", an = "Yemen", en = "Zambia", nn = "Zimbabwe", ym = {
  Afghanistan: a,
  "Åland Islands": "Åland Islands",
  Albania: e,
  Algeria: n,
  "American Samoa": "American Samoa",
  Andorra: i,
  Angola: o,
  Anguilla: r,
  Antarctica: t,
  "Antigua and Barbuda": "Antigua and Barbuda",
  Argentina: c,
  Armenia: s,
  Aruba: d,
  Australia: u,
  Austria: g,
  Azerbaijan: l,
  Bahamas: m,
  Bahrain: b,
  Bangladesh: h,
  Barbados: S,
  Belarus: p,
  Belgium: A,
  Belize: $,
  Benin: I,
  Bermuda: y,
  Bhutan: M,
  "Bolivia (Plurinational State of)": "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba": "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina": "Bosnia and Herzegovina",
  Botswana: C,
  "Bouvet Island": "Bouvet Island",
  Brazil: B,
  "British Indian Ocean Territory": "British Indian Ocean Territory",
  "Brunei Darussalam": "Brunei Darussalam",
  Bulgaria: E,
  "Burkina Faso": "Burkina Faso",
  Burundi: O,
  "Cabo Verde": "Cabo Verde",
  Cambodia: G,
  Cameroon: N,
  Canada: T,
  "Cayman Islands": "Cayman Islands",
  "Central African Republic": "Central African Republic",
  Chad: L,
  Chile: f,
  China: P,
  "Christmas Island": "Christmas Island",
  "Cocos (Keeling) Islands": "Cocos (Keeling) Islands",
  Colombia: _,
  Comoros: R,
  Congo: k,
  "Congo, Democratic Republic of the": "Congo, Democratic Republic of the",
  "Cook Islands": "Cook Islands",
  "Costa Rica": "Costa Rica",
  "Côte d'Ivoire": "Côte d'Ivoire",
  Croatia: K,
  Cuba: v,
  Curaçao: "Curaçao",
  Cyprus: U,
  Czechia: z,
  Denmark: F,
  Djibouti: w,
  Dominica: D,
  "Dominican Republic": "Dominican Republic",
  Ecuador: H,
  Egypt: V,
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Equatorial Guinea",
  Eritrea: W,
  Estonia: Z,
  Eswatini: J,
  Ethiopia: j,
  "Falkland Islands (Malvinas)": "Falkland Islands (Malvinas)",
  "Faroe Islands": "Faroe Islands",
  Fiji: q,
  Finland: x,
  France: Y,
  "French Guiana": "French Guiana",
  "French Polynesia": "French Polynesia",
  "French Southern Territories": "French Southern Territories",
  Gabon: Q,
  Gambia: X,
  Georgia: aa,
  Germany: ea,
  Ghana: na,
  Gibraltar: ia,
  Greece: oa,
  Greenland: ra,
  Grenada: ta,
  Guadeloupe: ca,
  Guam: sa,
  Guatemala: da,
  Guernsey: ua,
  Guinea: ga,
  "Guinea-Bissau": "Guinea-Bissau",
  Guyana: la,
  Haiti: ma,
  "Heard Island and McDonald Islands": "Heard Island and McDonald Islands",
  "Holy See": "Holy See",
  Honduras: ba,
  "Hong Kong": "Hong Kong",
  Hungary: ha,
  Iceland: Sa,
  India: pa,
  Indonesia: Aa,
  "Iran (Islamic Republic of)": "Iran (Islamic Republic of)",
  Iraq: $a,
  Ireland: Ia,
  "Isle of Man": "Isle of Man",
  Israel: ya,
  Italy: Ma,
  Jamaica: Ca,
  Japan: Ba,
  Jersey: Ea,
  Jordan: Oa,
  Kazakhstan: Ga,
  Kenya: Na,
  Kiribati: Ta,
  "Korea (Democratic People's Republic of)": "Korea (Democratic People's Republic of)",
  "Korea, Republic of": "Korea, Republic of",
  Kuwait: La,
  Kyrgyzstan: fa,
  "Lao People's Democratic Republic": "Lao People's Democratic Republic",
  Latvia: Pa,
  Lebanon: _a,
  Lesotho: Ra,
  Liberia: ka,
  Libya: Ka,
  Liechtenstein: va,
  Lithuania: Ua,
  Luxembourg: za,
  Macao: Fa,
  Madagascar: wa,
  Malawi: Da,
  Malaysia: Ha,
  Maldives: Va,
  Mali: Wa,
  Malta: Za,
  "Marshall Islands": "Marshall Islands",
  Martinique: Ja,
  Mauritania: ja,
  Mauritius: qa,
  Mayotte: xa,
  Mexico: Ya,
  "Micronesia (Federated States of)": "Micronesia (Federated States of)",
  "Moldova, Republic of": "Moldova, Republic of",
  Monaco: Qa,
  Mongolia: Xa,
  Montenegro: ae,
  Montserrat: ee,
  Morocco: ne,
  Mozambique: ie,
  Myanmar: oe,
  Namibia: re,
  Nauru: te,
  Nepal: ce,
  Netherlands: se,
  "New Caledonia": "New Caledonia",
  "New Zealand": "New Zealand",
  Nicaragua: de,
  Niger: ue,
  Nigeria: ge,
  Niue: le,
  "Norfolk Island": "Norfolk Island",
  "North Macedonia": "North Macedonia",
  "Northern Mariana Islands": "Northern Mariana Islands",
  Norway: me,
  Oman: be,
  Pakistan: he,
  Palau: Se,
  "Palestine, State of": "Palestine, State of",
  Panama: pe,
  "Papua New Guinea": "Papua New Guinea",
  Paraguay: Ae,
  Peru: $e,
  Philippines: Ie,
  Pitcairn: ye,
  Poland: Me,
  Portugal: Ce,
  "Puerto Rico": "Puerto Rico",
  Qatar: Be,
  Réunion: "Réunion",
  Romania: Ee,
  "Russian Federation": "Russian Federation",
  Rwanda: Oe,
  "Saint Barthélemy": "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha": "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis": "Saint Kitts and Nevis",
  "Saint Lucia": "Saint Lucia",
  "Sint Maarten (Dutch part)": "Sint Maarten (Dutch part)",
  "Saint Martin (French part)": "Saint Martin (French part)",
  "Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
  Samoa: Ge,
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Sao Tome and Principe",
  "Saudi Arabia": "Saudi Arabia",
  Senegal: Ne,
  Serbia: Te,
  Seychelles: Le,
  "Sierra Leone": "Sierra Leone",
  Singapore: fe,
  Slovakia: Pe,
  Slovenia: _e,
  "Solomon Islands": "Solomon Islands",
  Somalia: Re,
  "South Africa": "South Africa",
  "South Georgia and the South Sandwich Islands": "South Georgia and the South Sandwich Islands",
  "South Sudan": "South Sudan",
  Spain: ke,
  "Sri Lanka": "Sri Lanka",
  Sudan: Ke,
  Suriname: ve,
  "Svalbard and Jan Mayen": "Svalbard and Jan Mayen",
  Sweden: Ue,
  Switzerland: ze,
  "Syrian Arab Republic": "Syrian Arab Republic",
  "Taiwan, Province of China": "Taiwan, Province of China",
  Tajikistan: Fe,
  "Tanzania, United Republic of": "Tanzania, United Republic of",
  Thailand: we,
  "Timor-Leste": "Timor-Leste",
  Togo: De,
  Tokelau: He,
  Tonga: Ve,
  "Trinidad and Tobago": "Trinidad and Tobago",
  Tunisia: We,
  Turkey: Ze,
  Turkmenistan: Je,
  "Turks and Caicos Islands": "Turks and Caicos Islands",
  Tuvalu: je,
  Uganda: qe,
  Ukraine: xe,
  "United Arab Emirates": "United Arab Emirates",
  "United Kingdom of Great Britain and Northern Ireland": "United Kingdom of Great Britain and Northern Ireland",
  "United States of America": "United States of America",
  "United States Minor Outlying Islands": "United States Minor Outlying Islands",
  Uruguay: Ye,
  Uzbekistan: Qe,
  Vanuatu: Xe,
  "Venezuela (Bolivarian Republic of)": "Venezuela (Bolivarian Republic of)",
  "Viet Nam": "Viet Nam",
  "Virgin Islands (British)": "Virgin Islands (British)",
  "Virgin Islands (U.S.)": "Virgin Islands (U.S.)",
  "Wallis and Futuna": "Wallis and Futuna",
  "Western Sahara": "Western Sahara",
  Yemen: an,
  Zambia: en,
  Zimbabwe: nn
}, on = "Afganistán", rn = "Albania", tn = "Argelia", cn = "Andorra", sn = "Angola", dn = "Anguila", un = "Antártida", gn = "Argentina", ln = "Armenia", mn = "Aruba", bn = "Australia", hn = "Austria", Sn = "Azerbaiyán", pn = "Bahamas", An = "Baréin", $n = "Bangladés", In = "Barbados", yn = "Bielorrusia", Mn = "Bélgica", Cn = "Belice", Bn = "Benín", En = "Bermudas", On = "Bután", Gn = "Botsuana", Nn = "Brasil", Tn = "Bulgaria", Ln = "Burundi", fn = "Camboya", Pn = "Camerún", _n = "Canadá", Rn = "Chad", kn = "Chile", Kn = "China", vn = "Colombia", Un = "Comoras", zn = "Congo", Fn = "Croacia", wn = "Cuba", Dn = "Chipre", Hn = "Chequia", Vn = "Dinamarca", Wn = "Yibuti", Zn = "Dominica", Jn = "Ecuador", jn = "Egipto", qn = "Eritrea", xn = "Estonia", Yn = "Suazilandia", Qn = "Etiopía", Xn = "Fiyi", ai = "Finlandia", ei = "Francia", ni = "Gabón", ii = "Gambia", oi = "Georgia", ri = "Alemania", ti = "Ghana", ci = "Gibraltar", si = "Grecia", di = "Groenlandia", ui = "Granada", gi = "Guadalupe", li = "Guam", mi = "Guatemala", bi = "Guernsey", hi = "Guinea", Si = "Guyana", pi = "Haití", Ai = "Honduras", $i = "Hungría", Ii = "Islandia", yi = "India", Mi = "Indonesia", Ci = "Irak", Bi = "Irlanda", Ei = "Israel", Oi = "Italia", Gi = "Jamaica", Ni = "Japón", Ti = "Jersey", Li = "Jordania", fi = "Kazajistán", Pi = "Kenia", _i = "Kiribati", Ri = "Kuwait", ki = "Kirguistán", Ki = "Letonia", vi = "Líbano", Ui = "Lesoto", zi = "Liberia", Fi = "Libia", wi = "Liechtenstein", Di = "Lituania", Hi = "Luxemburgo", Vi = "Macao", Wi = "Madagascar", Zi = "Malaui", Ji = "Malasia", ji = "Maldivas", qi = "Malí", xi = "Malta", Yi = "Martinica", Qi = "Mauritania", Xi = "Mauricio", ao = "Mayotte", eo = "México", no = "Mónaco", io = "Mongolia", oo = "Montenegro", ro = "Montserrat", to = "Marruecos", co = "Mozambique", so = "Myanmar (Birmania)", uo = "Namibia", go = "Nauru", lo = "Nepal", mo = "Países Bajos", bo = "Nicaragua", ho = "Níger", So = "Nigeria", po = "Niue", Ao = "Noruega", $o = "Omán", Io = "Pakistán", yo = "Palaos", Mo = "Panamá", Co = "Paraguay", Bo = "Perú", Eo = "Filipinas", Oo = "Islas Pitcairn", Go = "Polonia", No = "Portugal", To = "Catar", Lo = "Rumanía", fo = "Ruanda", Po = "Samoa", _o = "Senegal", Ro = "Serbia", ko = "Seychelles", Ko = "Singapur", vo = "Eslovaquia", Uo = "Eslovenia", zo = "Somalia", Fo = "España", wo = "Sudán", Do = "Surinam", Ho = "Suecia", Vo = "Suiza", Wo = "Tayikistán", Zo = "Tailandia", Jo = "Togo", jo = "Tokelau", qo = "Tonga", xo = "Túnez", Yo = "Turquía", Qo = "Turkmenistán", Xo = "Tuvalu", ar = "Uganda", er = "Ucrania", nr = "Uruguay", ir = "Uzbekistán", or = "Vanuatu", rr = "Yemen", tr = "Zambia", cr = "Zimbabue", Mm = {
  Afghanistan: on,
  "Åland Islands": "Islas Åland",
  Albania: rn,
  Algeria: tn,
  "American Samoa": "Samoa Americana",
  Andorra: cn,
  Angola: sn,
  Anguilla: dn,
  Antarctica: un,
  "Antigua and Barbuda": "Antigua y Barbuda",
  Argentina: gn,
  Armenia: ln,
  Aruba: mn,
  Australia: bn,
  Austria: hn,
  Azerbaijan: Sn,
  Bahamas: pn,
  Bahrain: An,
  Bangladesh: $n,
  Barbados: In,
  Belarus: yn,
  Belgium: Mn,
  Belize: Cn,
  Benin: Bn,
  Bermuda: En,
  Bhutan: On,
  "Bolivia (Plurinational State of)": "Bolivia",
  "Bonaire, Sint Eustatius and Saba": "Bonaire, San Eustaquio y Saba",
  "Bosnia and Herzegovina": "Bosnia y Herzegovina",
  Botswana: Gn,
  "Bouvet Island": "Isla Bouvet",
  Brazil: Nn,
  "British Indian Ocean Territory": "Territorio Británico del Océano Índico",
  "Brunei Darussalam": "Brunéi",
  Bulgaria: Tn,
  "Burkina Faso": "Burkina Faso",
  Burundi: Ln,
  "Cabo Verde": "Cabo Verde",
  Cambodia: fn,
  Cameroon: Pn,
  Canada: _n,
  "Cayman Islands": "Islas Caimán",
  "Central African Republic": "República Centroafricana",
  Chad: Rn,
  Chile: kn,
  China: Kn,
  "Christmas Island": "Isla de Navidad",
  "Cocos (Keeling) Islands": "Islas Cocos (Keeling)",
  Colombia: vn,
  Comoros: Un,
  Congo: zn,
  "Congo, Democratic Republic of the": "Congo (Rep. Dem.)",
  "Cook Islands": "Islas Cook",
  "Costa Rica": "Costa Rica",
  "Côte d'Ivoire": "Costa de Marfil",
  Croatia: Fn,
  Cuba: wn,
  Curaçao: "Curazao",
  Cyprus: Dn,
  Czechia: Hn,
  Denmark: Vn,
  Djibouti: Wn,
  Dominica: Zn,
  "Dominican Republic": "República Dominicana",
  Ecuador: Jn,
  Egypt: jn,
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Guinea Ecuatorial",
  Eritrea: qn,
  Estonia: xn,
  Eswatini: Yn,
  Ethiopia: Qn,
  "Falkland Islands (Malvinas)": "Islas Malvinas",
  "Faroe Islands": "Islas Feroe",
  Fiji: Xn,
  Finland: ai,
  France: ei,
  "French Guiana": "Guayana Francesa",
  "French Polynesia": "Polinesia Francesa",
  "French Southern Territories": "Territorios Australes Franceses",
  Gabon: ni,
  Gambia: ii,
  Georgia: oi,
  Germany: ri,
  Ghana: ti,
  Gibraltar: ci,
  Greece: si,
  Greenland: di,
  Grenada: ui,
  Guadeloupe: gi,
  Guam: li,
  Guatemala: mi,
  Guernsey: bi,
  Guinea: hi,
  "Guinea-Bissau": "Guinea-Bisáu",
  Guyana: Si,
  Haiti: pi,
  "Heard Island and McDonald Islands": "Islas Heard y McDonald",
  "Holy See": "Santa Sede (Ciudad del Vaticano)",
  Honduras: Ai,
  "Hong Kong": "Hong Kong",
  Hungary: $i,
  Iceland: Ii,
  India: yi,
  Indonesia: Mi,
  "Iran (Islamic Republic of)": "Irán",
  Iraq: Ci,
  Ireland: Bi,
  "Isle of Man": "Isla de Man",
  Israel: Ei,
  Italy: Oi,
  Jamaica: Gi,
  Japan: Ni,
  Jersey: Ti,
  Jordan: Li,
  Kazakhstan: fi,
  Kenya: Pi,
  Kiribati: _i,
  "Korea (Democratic People's Republic of)": "Corea del Norte",
  "Korea, Republic of": "Corea del Sur",
  Kuwait: Ri,
  Kyrgyzstan: ki,
  "Lao People's Democratic Republic": "Laos",
  Latvia: Ki,
  Lebanon: vi,
  Lesotho: Ui,
  Liberia: zi,
  Libya: Fi,
  Liechtenstein: wi,
  Lithuania: Di,
  Luxembourg: Hi,
  Macao: Vi,
  Madagascar: Wi,
  Malawi: Zi,
  Malaysia: Ji,
  Maldives: ji,
  Mali: qi,
  Malta: xi,
  "Marshall Islands": "Islas Marshall",
  Martinique: Yi,
  Mauritania: Qi,
  Mauritius: Xi,
  Mayotte: ao,
  Mexico: eo,
  "Micronesia (Federated States of)": "Micronesia",
  "Moldova, Republic of": "Moldavia",
  Monaco: no,
  Mongolia: io,
  Montenegro: oo,
  Montserrat: ro,
  Morocco: to,
  Mozambique: co,
  Myanmar: so,
  Namibia: uo,
  Nauru: go,
  Nepal: lo,
  Netherlands: mo,
  "New Caledonia": "Nueva Caledonia",
  "New Zealand": "Nueva Zelanda",
  Nicaragua: bo,
  Niger: ho,
  Nigeria: So,
  Niue: po,
  "Norfolk Island": "Isla Norfolk",
  "North Macedonia": "Macedonia del Norte",
  "Northern Mariana Islands": "Islas Marianas del Norte",
  Norway: Ao,
  Oman: $o,
  Pakistan: Io,
  Palau: yo,
  "Palestine, State of": "Palestina",
  Panama: Mo,
  "Papua New Guinea": "Papúa Nueva Guinea",
  Paraguay: Co,
  Peru: Bo,
  Philippines: Eo,
  Pitcairn: Oo,
  Poland: Go,
  Portugal: No,
  "Puerto Rico": "Puerto Rico",
  Qatar: To,
  Réunion: "Reunión",
  Romania: Lo,
  "Russian Federation": "Rusia",
  Rwanda: fo,
  "Saint Barthélemy": "San Bartolomé",
  "Saint Helena, Ascension and Tristan da Cunha": "Santa Elena, Ascensión y Tristán de Acuña",
  "Saint Kitts and Nevis": "San Cristóbal y Nieves",
  "Saint Lucia": "Santa Lucía",
  "Saint Martin (French part)": "San Martín",
  "Saint Pierre and Miquelon": "San Pedro y Miquelón",
  "Saint Vincent and the Grenadines": "San Vicente y las Granadinas",
  Samoa: Po,
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Santo Tomé y Príncipe",
  "Saudi Arabia": "Arabia Saudita",
  Senegal: _o,
  Serbia: Ro,
  Seychelles: ko,
  "Sierra Leone": "Sierra Leona",
  Singapore: Ko,
  "Sint Maarten (Dutch part)": "San Martín",
  Slovakia: vo,
  Slovenia: Uo,
  "Solomon Islands": "Islas Salomón",
  Somalia: zo,
  "South Africa": "Sudáfrica",
  "South Georgia and the South Sandwich Islands": "Islas Georgia del Sur y Sandwich del Sur",
  "South Sudan": "Sudán del Sur",
  Spain: Fo,
  "Sri Lanka": "Sri Lanka",
  Sudan: wo,
  Suriname: Do,
  "Svalbard and Jan Mayen": "Svalbard y Jan Mayen",
  Sweden: Ho,
  Switzerland: Vo,
  "Syrian Arab Republic": "Siria",
  "Taiwan, Province of China": "Taiwán",
  Tajikistan: Wo,
  "Tanzania, United Republic of": "Tanzania",
  Thailand: Zo,
  "Timor-Leste": "Timor Oriental",
  Togo: Jo,
  Tokelau: jo,
  Tonga: qo,
  "Trinidad and Tobago": "Trinidad y Tobago",
  Tunisia: xo,
  Turkey: Yo,
  Turkmenistan: Qo,
  "Turks and Caicos Islands": "Islas Turcas y Caicos",
  Tuvalu: Xo,
  Uganda: ar,
  Ukraine: er,
  "United Arab Emirates": "Emiratos Árabes Unidos",
  "United Kingdom of Great Britain and Northern Ireland": "Reino Unido",
  "United States of America": "Estados Unidos",
  "United States Minor Outlying Islands": "Islas Ultramarinas Menores de Estados Unidos",
  Uruguay: nr,
  Uzbekistan: ir,
  Vanuatu: or,
  "Venezuela (Bolivarian Republic of)": "Venezuela",
  "Viet Nam": "Vietnam",
  "Virgin Islands (British)": "Islas Vírgenes Británicas",
  "Virgin Islands (U.S.)": "Islas Vírgenes de los Estados Unidos",
  "Wallis and Futuna": "Wallis y Futuna",
  "Western Sahara": "Sáhara Occidental",
  Yemen: rr,
  Zambia: tr,
  Zimbabwe: cr
}, sr = "Afganistan", dr = "Albania", ur = "Aljeria", gr = "Andorra", lr = "Angola", mr = "Argentina", br = "Armenia", hr = "Australia", Sr = "Austria", pr = "Azerbaijan", Ar = "Bahamak", $r = "Bahrain", Ir = "Bangladesh", yr = "Barbados", Mr = "Bielorrusia", Cr = "Belgika", Br = "Belize", Er = "Benin", Or = "Bhutan", Gr = "Botswana", Nr = "Brasil", Tr = "Bulgaria", Lr = "Burundi", fr = "Kanbodia", Pr = "Kamerun", _r = "Kanada", Rr = "Txad", kr = "Txile", Kr = "Txina", vr = "Kolombia", Ur = "Comoreak", zr = "Kongo", Fr = "Kroazia", wr = "Kuba", Dr = "Zipre", Hr = "Txekia", Vr = "Danimarka", Wr = "Djibuti", Zr = "Dominika", Jr = "Ekuador", jr = "Egipto", qr = "Eritrea", xr = "Estonia", Yr = "Eswatini", Qr = "Etiopia", Xr = "Fiji", at = "Finlandia", et = "Frantzia", nt = "Gabon", it = "Gambia", ot = "Georgia", rt = "Alemania", tt = "Ghana", ct = "Grezia", st = "Grenada", dt = "Guatemala", ut = "Ginea", gt = "Guyana", lt = "Haiti", mt = "Honduras", bt = "Hungaria", ht = "Islandia", St = "India", pt = "Indonesia", At = "Irak", $t = "Irlanda", It = "Israel", yt = "Italia", Mt = "Jamaika", Ct = "Japonia", Bt = "Jordania", Et = "Kazajistan", Ot = "Kenya", Gt = "Kiribati", Nt = "Kuwait", Tt = "Kirgizistan", Lt = "Letonia", ft = "Libano", Pt = "Lesotho", _t = "Liberia", Rt = "Libia", kt = "Liechtenstein", Kt = "Lituania", vt = "Luxenburgo", Ut = "Madagaskar", zt = "Malawi", Ft = "Malaysia", wt = "Maldivak", Dt = "Mali", Ht = "Malta", Vt = "Mauritania", Wt = "Maurizio", Zt = "Mexiko", Jt = "Monako", jt = "Mongolia", qt = "Montenegro", xt = "Maroko", Yt = "Mozambike", Qt = "Myanmar", Xt = "Namibia", ac = "Nauru", ec = "Nepal", nc = "Herbehereak", ic = "Nikaragua", oc = "Niger", rc = "Nigeria", tc = "Norvegia", cc = "Oman", sc = "Pakistan", dc = "Palau", uc = "Panama", gc = "Paraguai", lc = "Peru", mc = "Filipinak", bc = "Polonia", hc = "Portugal", Sc = "Qatar", pc = "Errumania", Ac = "Ruanda", $c = "Samoa", Ic = "Senegal", yc = "Serbia", Mc = "Seychelleak", Cc = "Singapur", Bc = "Eslovakia", Ec = "Eslovenia", Oc = "Somalia", Gc = "Espainia", Nc = "Sudan", Tc = "Surinam", Lc = "Suedia", fc = "Suitza", Pc = "Tajikistan", _c = "Thailandia", Rc = "Togo", kc = "Tonga", Kc = "Tunisia", vc = "Turkia", Uc = "Turkmenistan", zc = "Tuvalu", Fc = "Uganda", wc = "Ukraina", Dc = "Uruguai", Hc = "Uzbekistan", Vc = "Vanuatu", Wc = "Yemen", Zc = "Zambia", Jc = "Zimbabwe", Cm = {
  Afghanistan: sr,
  Albania: dr,
  Algeria: ur,
  Andorra: gr,
  Angola: lr,
  "Antigua and Barbuda": "Antigua eta Barbuda",
  Argentina: mr,
  Armenia: br,
  Australia: hr,
  Austria: Sr,
  Azerbaijan: pr,
  Bahamas: Ar,
  Bahrain: $r,
  Bangladesh: Ir,
  Barbados: yr,
  Belarus: Mr,
  Belgium: Cr,
  Belize: Br,
  Benin: Er,
  Bhutan: Or,
  "Bolivia (Plurinational State of)": "Bolivia (Plurinazional Estatu)",
  "Bosnia and Herzegovina": "Bosnia eta Herzegovina",
  Botswana: Gr,
  Brazil: Nr,
  "Brunei Darussalam": "Brunei Darussalam",
  Bulgaria: Tr,
  "Burkina Faso": "Burkina Faso",
  Burundi: Lr,
  "Cabo Verde": "Cabo Verde",
  Cambodia: fr,
  Cameroon: Pr,
  Canada: _r,
  "Central African Republic": "Afrika Erdiko Errepublika",
  Chad: Rr,
  Chile: kr,
  China: Kr,
  Colombia: vr,
  Comoros: Ur,
  Congo: zr,
  "Costa Rica": "Costa Rica",
  "Côte d'Ivoire": "Bakote Itsasoz",
  Croatia: Fr,
  Cuba: wr,
  Cyprus: Dr,
  Czechia: Hr,
  Denmark: Vr,
  Djibouti: Wr,
  Dominica: Zr,
  "Dominican Republic": "Dominikar Errepublika",
  Ecuador: Jr,
  Egypt: jr,
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Ekuatore Ginea",
  Eritrea: qr,
  Estonia: xr,
  Eswatini: Yr,
  Ethiopia: Qr,
  Fiji: Xr,
  Finland: at,
  France: et,
  Gabon: nt,
  Gambia: it,
  Georgia: ot,
  Germany: rt,
  Ghana: tt,
  Greece: ct,
  Grenada: st,
  Guatemala: dt,
  Guinea: ut,
  "Guinea-Bissau": "Ginea-Bissau",
  Guyana: gt,
  Haiti: lt,
  Honduras: mt,
  Hungary: bt,
  Iceland: ht,
  India: St,
  Indonesia: pt,
  "Iran (Islamic Republic of)": "Iran (Erresuma Islamikoa)",
  Iraq: At,
  Ireland: $t,
  Israel: It,
  Italy: yt,
  Jamaica: Mt,
  Japan: Ct,
  Jordan: Bt,
  Kazakhstan: Et,
  Kenya: Ot,
  Kiribati: Gt,
  "Korea (Democratic People's Republic of)": "Korea (Herri Errepublika Demokratikoa)",
  "Korea, Republic of": "Korea (Errepublika)",
  Kuwait: Nt,
  Kyrgyzstan: Tt,
  "Lao People's Democratic Republic": "Laos (Herri Errepublika Demokratikoa)",
  Latvia: Lt,
  Lebanon: ft,
  Lesotho: Pt,
  Liberia: _t,
  Libya: Rt,
  Liechtenstein: kt,
  Lithuania: Kt,
  Luxembourg: vt,
  Madagascar: Ut,
  Malawi: zt,
  Malaysia: Ft,
  Maldives: wt,
  Mali: Dt,
  Malta: Ht,
  "Marshall Islands": "Marshall uharteak",
  Mauritania: Vt,
  Mauritius: Wt,
  Mexico: Zt,
  "Micronesia (Federated States of)": "Mikronesia (Estatu Federatuak)",
  "Moldova, Republic of": "Moldavia (Erresuma)",
  Monaco: Jt,
  Mongolia: jt,
  Montenegro: qt,
  Morocco: xt,
  Mozambique: Yt,
  Myanmar: Qt,
  Namibia: Xt,
  Nauru: ac,
  Nepal: ec,
  Netherlands: nc,
  "New Zealand": "Zelanda Berria",
  Nicaragua: ic,
  Niger: oc,
  Nigeria: rc,
  "North Macedonia": "Mazedonia (Ipar)",
  Norway: tc,
  Oman: cc,
  Pakistan: sc,
  Palau: dc,
  Panama: uc,
  "Papua New Guinea": "Papua Ginea Berria",
  Paraguay: gc,
  Peru: lc,
  Philippines: mc,
  Poland: bc,
  Portugal: hc,
  Qatar: Sc,
  Réunion: "Réunion",
  Romania: pc,
  "Russian Federation": "Errusia (Federazioko Erresuma)",
  Rwanda: Ac,
  "Saint Kitts and Nevis": "Saint Kitts eta Nevis",
  "Saint Lucia": "Santa Luzia",
  "Saint Vincent and the Grenadines": "Saint Vincent eta Grenadinak",
  Samoa: $c,
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Sao Tome eta Principe",
  "Saudi Arabia": "Arabia Saudi",
  Senegal: Ic,
  Serbia: yc,
  Seychelles: Mc,
  "Sierra Leone": "Sierra Leona",
  Singapore: Cc,
  Slovakia: Bc,
  Slovenia: Ec,
  "Solomon Islands": "Salomon uharteak",
  Somalia: Oc,
  "South Africa": "Hegoafrika",
  "South Sudan": "Hego Sudan",
  Spain: Gc,
  "Sri Lanka": "Sri Lanka",
  Sudan: Nc,
  Suriname: Tc,
  Sweden: Lc,
  Switzerland: fc,
  "Syrian Arab Republic": "Siria (Arabiar Erresuma)",
  "Taiwan, Province of China": "Taiwan (Txinako Probintzia)",
  Tajikistan: Pc,
  "Tanzania, United Republic of": "Tanzania (Erresuma Batua)",
  Thailand: _c,
  "Timor-Leste": "Ekialdeko Timor",
  Togo: Rc,
  Tonga: kc,
  "Trinidad and Tobago": "Trinidad eta Tobago",
  Tunisia: Kc,
  Turkey: vc,
  Turkmenistan: Uc,
  Tuvalu: zc,
  Uganda: Fc,
  Ukraine: wc,
  "United Arab Emirates": "Arabiar Emirerri Batuak",
  "United Kingdom of Great Britain and Northern Ireland": "Erresuma Batuko Erresuma Batua",
  "United States of America": "Ameriketako Estatu Batuak",
  Uruguay: Dc,
  Uzbekistan: Hc,
  Vanuatu: Vc,
  "Venezuela (Bolivarian Republic of)": "Venezuela (Bolivar Errepublika)",
  "Viet Nam": "Vietnam",
  Yemen: Wc,
  Zambia: Zc,
  Zimbabwe: Jc
}, jc = "Afganistan", qc = "Albània", xc = "Algèria", Yc = "Andorra", Qc = "Angola", Xc = "Argentina", as = "Armènia", es = "Austràlia", ns = "Àustria", is = "Azerbaidjan", os = "Bahames", rs = "Bahrain", ts = "Bangla Desh", cs = "Barbados", ss = "Bielorússia", ds = "Bèlgica", us = "Belize", gs = "Benín", ls = "Bhutan", ms = "Botswana", bs = "Brasil", hs = "Bulgària", Ss = "Burundi", ps = "Cambodja", As = "Camerun", $s = "Canadà", Is = "Txad", ys = "Xile", Ms = "Xina", Cs = "Colòmbia", Bs = "Comores", Es = "Congo", Os = "Croàcia", Gs = "Cuba", Ns = "Xipre", Ts = "Txèquia", Ls = "Dinamarca", fs = "Djibouti", Ps = "Dominica", _s = "Equador", Rs = "Egipte", ks = "Eritrea", Ks = "Estònia", vs = "Eswatini", Us = "Etiòpia", zs = "Fiji", Fs = "Finlàndia", ws = "França", Ds = "Gabon", Hs = "Gàmbia", Vs = "Geòrgia", Ws = "Alemanya", Zs = "Ghana", Js = "Grècia", js = "Grenada", qs = "Guatemala", xs = "Guinea", Ys = "Guyana", Qs = "Haití", Xs = "Hondures", ad = "Hongria", ed = "Islàndia", nd = "Índia", id = "Indonèsia", od = "Iraq", rd = "Irlanda", td = "Israel", cd = "Itàlia", sd = "Jamaica", dd = "Japó", ud = "Jordània", gd = "Kazakhstan", ld = "Kenya", md = "Kiribati", bd = "Kuwait", hd = "Kirguizistan", Sd = "Letònia", pd = "Líban", Ad = "Lesotho", $d = "Libèria", Id = "Líbia", yd = "Liechtenstein", Md = "Lituània", Cd = "Luxemburg", Bd = "Madagascar", Ed = "Malawi", Od = "Malàisia", Gd = "Maldives", Nd = "Mali", Td = "Malta", Ld = "Mauritània", fd = "Maurici", Pd = "Mèxic", _d = "Mònaco", Rd = "Mongòlia", kd = "Montenegro", Kd = "Marroc", vd = "Moçambic", Ud = "Myanmar", zd = "Namíbia", Fd = "Nauru", wd = "Nepal", Dd = "Països Baixos", Hd = "Nicaragua", Vd = "Níger", Wd = "Nigèria", Zd = "Noruega", Jd = "Oman", jd = "Pakistan", qd = "Palau", xd = "Panamà", Yd = "Paraguai", Qd = "Perú", Xd = "Filipines", au = "Polònia", eu = "Portugal", nu = "Qatar", iu = "Romania", ou = "Ruanda", ru = "Samoa", tu = "Senegal", cu = "Sèrbia", su = "Seychelles", du = "Singapur", uu = "Eslovàquia", gu = "Eslovènia", lu = "Somàlia", mu = "Espanya", bu = "Sudan", hu = "Surinam", Su = "Suècia", pu = "Suïssa", Au = "Tadjikistan", $u = "Tailàndia", Iu = "Togo", yu = "Tonga", Mu = "Tunísia", Cu = "Turquia", Bu = "Turkmenistan", Eu = "Tuvalu", Ou = "Uganda", Gu = "Ucraïna", Nu = "Uruguai", Tu = "Uzbekistan", Lu = "Vanuatu", fu = "Iemen", Pu = "Zàmbia", _u = "Zimbàbue", Bm = {
  Afghanistan: jc,
  Albania: qc,
  Algeria: xc,
  Andorra: Yc,
  Angola: Qc,
  "Antigua and Barbuda": "Antigua i Barbuda",
  Argentina: Xc,
  Armenia: as,
  Australia: es,
  Austria: ns,
  Azerbaijan: is,
  Bahamas: os,
  Bahrain: rs,
  Bangladesh: ts,
  Barbados: cs,
  Belarus: ss,
  Belgium: ds,
  Belize: us,
  Benin: gs,
  Bhutan: ls,
  "Bolivia (Plurinational State of)": "Bolívia (Estat Plurinacional)",
  "Bosnia and Herzegovina": "Bòsnia i Hercegovina",
  Botswana: ms,
  Brazil: bs,
  "Brunei Darussalam": "Brunei",
  Bulgaria: hs,
  "Burkina Faso": "Burkina Faso",
  Burundi: Ss,
  "Cabo Verde": "Cap Verd",
  Cambodia: ps,
  Cameroon: As,
  Canada: $s,
  "Central African Republic": "República Centreafricana",
  Chad: Is,
  Chile: ys,
  China: Ms,
  Colombia: Cs,
  Comoros: Bs,
  Congo: Es,
  "Costa Rica": "Costa Rica",
  "Côte d'Ivoire": "Costa d'Ivori",
  Croatia: Os,
  Cuba: Gs,
  Cyprus: Ns,
  Czechia: Ts,
  Denmark: Ls,
  Djibouti: fs,
  Dominica: Ps,
  "Dominican Republic": "República Dominicana",
  Ecuador: _s,
  Egypt: Rs,
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Guinea Equatorial",
  Eritrea: ks,
  Estonia: Ks,
  Eswatini: vs,
  Ethiopia: Us,
  Fiji: zs,
  Finland: Fs,
  France: ws,
  Gabon: Ds,
  Gambia: Hs,
  Georgia: Vs,
  Germany: Ws,
  Ghana: Zs,
  Greece: Js,
  Grenada: js,
  Guatemala: qs,
  Guinea: xs,
  "Guinea-Bissau": "Guinea Bissau",
  Guyana: Ys,
  Haiti: Qs,
  Honduras: Xs,
  Hungary: ad,
  Iceland: ed,
  India: nd,
  Indonesia: id,
  "Iran (Islamic Republic of)": "Iran (República Islàmica)",
  Iraq: od,
  Ireland: rd,
  Israel: td,
  Italy: cd,
  Jamaica: sd,
  Japan: dd,
  Jordan: ud,
  Kazakhstan: gd,
  Kenya: ld,
  Kiribati: md,
  "Korea (Democratic People's Republic of)": "Corea (República Popular Democràtica)",
  "Korea, Republic of": "Corea (República de)",
  Kuwait: bd,
  Kyrgyzstan: hd,
  "Lao People's Democratic Republic": "Laos (República Democràtica Popular)",
  Latvia: Sd,
  Lebanon: pd,
  Lesotho: Ad,
  Liberia: $d,
  Libya: Id,
  Liechtenstein: yd,
  Lithuania: Md,
  Luxembourg: Cd,
  Madagascar: Bd,
  Malawi: Ed,
  Malaysia: Od,
  Maldives: Gd,
  Mali: Nd,
  Malta: Td,
  "Marshall Islands": "Illes Marshall",
  Mauritania: Ld,
  Mauritius: fd,
  Mexico: Pd,
  "Micronesia (Federated States of)": "Micronèsia (Estats Federats)",
  "Moldova, Republic of": "Moldàvia (República de)",
  Monaco: _d,
  Mongolia: Rd,
  Montenegro: kd,
  Morocco: Kd,
  Mozambique: vd,
  Myanmar: Ud,
  Namibia: zd,
  Nauru: Fd,
  Nepal: wd,
  Netherlands: Dd,
  "New Zealand": "Nova Zelanda",
  Nicaragua: Hd,
  Niger: Vd,
  Nigeria: Wd,
  "North Macedonia": "Macedònia del Nord",
  Norway: Zd,
  Oman: Jd,
  Pakistan: jd,
  Palau: qd,
  Panama: xd,
  "Papua New Guinea": "Papua Nova Guinea",
  Paraguay: Yd,
  Peru: Qd,
  Philippines: Xd,
  Poland: au,
  Portugal: eu,
  Qatar: nu,
  Réunion: "Reunió",
  Romania: iu,
  "Russian Federation": "Rússia (Federació)",
  Rwanda: ou,
  "Saint Kitts and Nevis": "Saint Kitts i Nevis",
  "Saint Lucia": "Santa Llúcia",
  "Saint Vincent and the Grenadines": "Saint Vincent i les Grenadines",
  Samoa: ru,
  "San Marino": "San Marino",
  "Sao Tome and Principe": "São Tomé i Príncipe",
  "Saudi Arabia": "Aràbia Saudita",
  Senegal: tu,
  Serbia: cu,
  Seychelles: su,
  "Sierra Leone": "Sierra Leone",
  Singapore: du,
  Slovakia: uu,
  Slovenia: gu,
  "Solomon Islands": "Illes Salomó",
  Somalia: lu,
  "South Africa": "Sud-àfrica",
  "South Sudan": "Sudan del Sud",
  Spain: mu,
  "Sri Lanka": "Sri Lanka",
  Sudan: bu,
  Suriname: hu,
  Sweden: Su,
  Switzerland: pu,
  "Syrian Arab Republic": "Síria (República Àrab)",
  "Taiwan, Province of China": "Taiwan (Província de la Xina)",
  Tajikistan: Au,
  "Tanzania, United Republic of": "Tanzània (República Unida)",
  Thailand: $u,
  "Timor-Leste": "Timor-Leste",
  Togo: Iu,
  Tonga: yu,
  "Trinidad and Tobago": "Trinitat i Tobago",
  Tunisia: Mu,
  Turkey: Cu,
  Turkmenistan: Bu,
  Tuvalu: Eu,
  Uganda: Ou,
  Ukraine: Gu,
  "United Arab Emirates": "Emirats Àrabs Units",
  "United Kingdom of Great Britain and Northern Ireland": "Regne Unit de Gran Bretanya i Irlanda del Nord",
  "United States of America": "Estats Units d'Amèrica",
  Uruguay: Nu,
  Uzbekistan: Tu,
  Vanuatu: Lu,
  "Venezuela (Bolivarian Republic of)": "Veneçuela (República Bolivariana)",
  "Viet Nam": "Vietnam",
  Yemen: fu,
  Zambia: Pu,
  Zimbabwe: _u
}, Ru = "Afganistán", ku = "Albania", Ku = "Alxeria", vu = "Andorra", Uu = "Angola", zu = "Arxentina", Fu = "Armenia", wu = "Australia", Du = "Austria", Hu = "Acerbaixán", Vu = "Bahamas", Wu = "Bahrein", Zu = "Bangladés", Ju = "Barbados", ju = "Bielorrusia", qu = "Bélxica", xu = "Belice", Yu = "Benín", Qu = "Bután", Xu = "Botsuana", ag = "Brasil", eg = "Bulgaria", ng = "Burundi", ig = "Camboxa", og = "Camerún", rg = "Canadá", tg = "Chad", cg = "Chile", sg = "China", dg = "Colombia", ug = "Comores", gg = "Congo", lg = "Croacia", mg = "Cuba", bg = "Chipre", hg = "Chequia", Sg = "Dinamarca", pg = "Xibuti", Ag = "Dominica", $g = "Ecuador", Ig = "Exipto", yg = "Eritrea", Mg = "Estonia", Cg = "Esuatini", Bg = "Etiopía", Eg = "Fixi", Og = "Finlandia", Gg = "Francia", Ng = "Gabón", Tg = "Gambia", Lg = "Xeorxia", fg = "Alemaña", Pg = "Gana", _g = "Grecia", Rg = "Granada", kg = "Guatemala", Kg = "Guinea", vg = "Güiana", Ug = "Haití", zg = "Honuras", Fg = "Hungría", wg = "Islandia", Dg = "India", Hg = "Indonesia", Vg = "Iraq", Wg = "Irlanda", Zg = "Israel", Jg = "Italia", jg = "Xamaica", qg = "Xapón", xg = "Xordania", Yg = "Kazajistán", Qg = "Kenia", Xg = "Kiribati", al = "Kuwait", el = "Quirguicistán", nl = "Letonia", il = "Líbano", ol = "Lesoto", rl = "Liberia", tl = "Libia", cl = "Liechtenstein", sl = "Lituania", dl = "Luxemburgo", ul = "Madagascar", gl = "Malaui", ll = "Malaisia", ml = "Maldivas", bl = "Malí", hl = "Malta", Sl = "Mauritania", pl = "Mauricio", Al = "México", $l = "Mónaco", Il = "Mongolia", yl = "Montenegro", Ml = "Marrocos", Cl = "Mozambique", Bl = "Birmania", El = "Namibia", Ol = "Nauru", Gl = "Nepal", Nl = "Países Baixos", Tl = "Nicaragua", Ll = "Níxer", fl = "Nixeria", Pl = "Noruega", _l = "Omán", Rl = "Paquistán", kl = "Palau", Kl = "Panamá", vl = "Paraguai", Ul = "Perú", zl = "Filipinas", Fl = "Polonia", wl = "Portugal", Dl = "Qatar", Hl = "Romanía", Vl = "Ruanda", Wl = "Samoa", Zl = "Senegal", Jl = "Serbia", jl = "Seychelles", ql = "Singapur", xl = "Eslovaquia", Yl = "Eslovenia", Ql = "Somalia", Xl = "España", am = "Sudán", em = "Surinam", nm = "Suecia", im = "Suíza", om = "Taxiquistán", rm = "Tailandia", tm = "Togo", cm = "Tonga", sm = "Tunisia", dm = "Turquía", um = "Turkmenistán", gm = "Tuvalu", lm = "Uganda", mm = "Ucraína", bm = "Uruguai", hm = "Uzbekistán", Sm = "Vanuatu", pm = "Iemen", Am = "Zambia", $m = "Zimbabue", Em = {
  Afghanistan: Ru,
  Albania: ku,
  Algeria: Ku,
  Andorra: vu,
  Angola: Uu,
  "Antigua and Barbuda": "Antiga e Barbuda",
  Argentina: zu,
  Armenia: Fu,
  Australia: wu,
  Austria: Du,
  Azerbaijan: Hu,
  Bahamas: Vu,
  Bahrain: Wu,
  Bangladesh: Zu,
  Barbados: Ju,
  Belarus: ju,
  Belgium: qu,
  Belize: xu,
  Benin: Yu,
  Bhutan: Qu,
  "Bolivia (Plurinational State of)": "Bolivia",
  "Bosnia and Herzegovina": "Bosnia e Hercegovina",
  Botswana: Xu,
  Brazil: ag,
  "Brunei Darussalam": "Brunei",
  Bulgaria: eg,
  "Burkina Faso": "Burkina Faso",
  Burundi: ng,
  "Cabo Verde": "Cabo Verde",
  Cambodia: ig,
  Cameroon: og,
  Canada: rg,
  "Central African Republic": "República Centroafricana",
  Chad: tg,
  Chile: cg,
  China: sg,
  Colombia: dg,
  Comoros: ug,
  Congo: gg,
  "Costa Rica": "Costa Rica",
  "Côte d'Ivoire": "Costa do Marfil",
  Croatia: lg,
  Cuba: mg,
  Cyprus: bg,
  Czechia: hg,
  Denmark: Sg,
  Djibouti: pg,
  Dominica: Ag,
  "Dominican Republic": "República Dominicana",
  Ecuador: $g,
  Egypt: Ig,
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Guinea Ecuatorial",
  Eritrea: yg,
  Estonia: Mg,
  Eswatini: Cg,
  Ethiopia: Bg,
  Fiji: Eg,
  Finland: Og,
  France: Gg,
  Gabon: Ng,
  Gambia: Tg,
  Georgia: Lg,
  Germany: fg,
  Ghana: Pg,
  Greece: _g,
  Grenada: Rg,
  Guatemala: kg,
  Guinea: Kg,
  "Guinea-Bissau": "Guinea-Bisáu",
  Guyana: vg,
  Haiti: Ug,
  Honduras: zg,
  Hungary: Fg,
  Iceland: wg,
  India: Dg,
  Indonesia: Hg,
  "Iran (Islamic Republic of)": "Irán",
  Iraq: Vg,
  Ireland: Wg,
  Israel: Zg,
  Italy: Jg,
  Jamaica: jg,
  Japan: qg,
  Jordan: xg,
  Kazakhstan: Yg,
  Kenya: Qg,
  Kiribati: Xg,
  "Korea (Democratic People's Republic of)": "Corea do Norte",
  "Korea, Republic of": "Corea do Sur",
  Kuwait: al,
  Kyrgyzstan: el,
  "Lao People's Democratic Republic": "Laos",
  Latvia: nl,
  Lebanon: il,
  Lesotho: ol,
  Liberia: rl,
  Libya: tl,
  Liechtenstein: cl,
  Lithuania: sl,
  Luxembourg: dl,
  Madagascar: ul,
  Malawi: gl,
  Malaysia: ll,
  Maldives: ml,
  Mali: bl,
  Malta: hl,
  "Marshall Islands": "Illas Marshall",
  Mauritania: Sl,
  Mauritius: pl,
  Mexico: Al,
  "Micronesia (Federated States of)": "Micronesia",
  "Moldova, Republic of": "Moldavia",
  Monaco: $l,
  Mongolia: Il,
  Montenegro: yl,
  Morocco: Ml,
  Mozambique: Cl,
  Myanmar: Bl,
  Namibia: El,
  Nauru: Ol,
  Nepal: Gl,
  Netherlands: Nl,
  "New Zealand": "Nova Celandia",
  Nicaragua: Tl,
  Niger: Ll,
  Nigeria: fl,
  "North Macedonia": "Macedonia do Norte",
  Norway: Pl,
  Oman: _l,
  Pakistan: Rl,
  Palau: kl,
  Panama: Kl,
  "Papua New Guinea": "Papúa Nova Guinea",
  Paraguay: vl,
  Peru: Ul,
  Philippines: zl,
  Poland: Fl,
  Portugal: wl,
  Qatar: Dl,
  Romania: Hl,
  "Russian Federation": "Rusia",
  Rwanda: Vl,
  "Saint Kitts and Nevis": "San Cristovo e Nevis",
  "Saint Lucia": "Santa Lucía",
  "Saint Vincent and the Grenadines": "San Vicente e as Granadinas",
  Samoa: Wl,
  "San Marino": "San Marino",
  "Sao Tome and Principe": "San Tomé e Príncipe",
  "Saudi Arabia": "Arabia Saudita",
  Senegal: Zl,
  Serbia: Jl,
  Seychelles: jl,
  "Sierra Leone": "Serra Leoa",
  Singapore: ql,
  Slovakia: xl,
  Slovenia: Yl,
  "Solomon Islands": "Illas Salomón",
  Somalia: Ql,
  "South Africa": "Sudáfrica",
  "South Sudan": "Sudán do Sur",
  Spain: Xl,
  "Sri Lanka": "Sri Lanka",
  Sudan: am,
  Suriname: em,
  Sweden: nm,
  Switzerland: im,
  "Syrian Arab Republic": "Siria",
  "Taiwan, Province of China": "Taiwán",
  Tajikistan: om,
  "Tanzania, United Republic of": "Tanzania",
  Thailand: rm,
  "Timor-Leste": "Timor Leste",
  Togo: tm,
  Tonga: cm,
  "Trinidad and Tobago": "Trinidad e Tobago",
  Tunisia: sm,
  Turkey: dm,
  Turkmenistan: um,
  Tuvalu: gm,
  Uganda: lm,
  Ukraine: mm,
  "United Arab Emirates": "Emiratos Árabes Unidos",
  "United Kingdom of Great Britain and Northern Ireland": "Reino Unido",
  "United States of America": "Estados Unidos",
  Uruguay: bm,
  Uzbekistan: hm,
  Vanuatu: Sm,
  "Venezuela (Bolivarian Republic of)": "Venezuela",
  "Viet Nam": "Vietnam",
  Yemen: pm,
  Zambia: Am,
  Zimbabwe: $m
}, Im = [
  {
    "alpha-2": "AF",
    "alpha-3": "AFG",
    "country-code": "004",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AF",
    name: "Afghanistan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "AX",
    "alpha-3": "ALA",
    "country-code": "248",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AX",
    name: "Åland Islands",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "AL",
    "alpha-3": "ALB",
    "country-code": "008",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AL",
    name: "Albania",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "DZ",
    "alpha-3": "DZA",
    "country-code": "012",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:DZ",
    name: "Algeria",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Northern Africa",
    "sub-region-code": "015"
  },
  {
    "alpha-2": "AS",
    "alpha-3": "ASM",
    "country-code": "016",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AS",
    name: "American Samoa",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "AD",
    "alpha-3": "AND",
    "country-code": "020",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AD",
    name: "Andorra",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "AO",
    "alpha-3": "AGO",
    "country-code": "024",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:AO",
    name: "Angola",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "AI",
    "alpha-3": "AIA",
    "country-code": "660",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:AI",
    name: "Anguilla",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "AQ",
    "alpha-3": "ATA",
    "country-code": "010",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AQ",
    name: "Antarctica",
    region: "",
    "region-code": "",
    "sub-region": "",
    "sub-region-code": ""
  },
  {
    "alpha-2": "AG",
    "alpha-3": "ATG",
    "country-code": "028",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:AG",
    name: "Antigua and Barbuda",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "AR",
    "alpha-3": "ARG",
    "country-code": "032",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:AR",
    name: "Argentina",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "AM",
    "alpha-3": "ARM",
    "country-code": "051",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AM",
    name: "Armenia",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "AW",
    "alpha-3": "ABW",
    "country-code": "533",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:AW",
    name: "Aruba",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "AU",
    "alpha-3": "AUS",
    "country-code": "036",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AU",
    name: "Australia",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Australia and New Zealand",
    "sub-region-code": "053"
  },
  {
    "alpha-2": "AT",
    "alpha-3": "AUT",
    "country-code": "040",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AT",
    name: "Austria",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "AZ",
    "alpha-3": "AZE",
    "country-code": "031",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AZ",
    name: "Azerbaijan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "BS",
    "alpha-3": "BHS",
    "country-code": "044",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:BS",
    name: "Bahamas",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "BH",
    "alpha-3": "BHR",
    "country-code": "048",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BH",
    name: "Bahrain",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "BD",
    "alpha-3": "BGD",
    "country-code": "050",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BD",
    name: "Bangladesh",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "BB",
    "alpha-3": "BRB",
    "country-code": "052",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:BB",
    name: "Barbados",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "BY",
    "alpha-3": "BLR",
    "country-code": "112",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BY",
    name: "Belarus",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "BE",
    "alpha-3": "BEL",
    "country-code": "056",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BE",
    name: "Belgium",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "BZ",
    "alpha-3": "BLZ",
    "country-code": "084",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:BZ",
    name: "Belize",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "BJ",
    "alpha-3": "BEN",
    "country-code": "204",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:BJ",
    name: "Benin",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "BM",
    "alpha-3": "BMU",
    "country-code": "060",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BM",
    name: "Bermuda",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Northern America",
    "sub-region-code": "021"
  },
  {
    "alpha-2": "BT",
    "alpha-3": "BTN",
    "country-code": "064",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BT",
    name: "Bhutan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "BO",
    "alpha-3": "BOL",
    "country-code": "068",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:BO",
    name: "Bolivia (Plurinational State of)",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "BQ",
    "alpha-3": "BES",
    "country-code": "535",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:BQ",
    name: "Bonaire, Sint Eustatius and Saba",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "BA",
    "alpha-3": "BIH",
    "country-code": "070",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BA",
    name: "Bosnia and Herzegovina",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "BW",
    "alpha-3": "BWA",
    "country-code": "072",
    "intermediate-region": "Southern Africa",
    "intermediate-region-code": "018",
    "iso_3166-2": "ISO 3166-2:BW",
    name: "Botswana",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "BV",
    "alpha-3": "BVT",
    "country-code": "074",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:BV",
    name: "Bouvet Island",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "BR",
    "alpha-3": "BRA",
    "country-code": "076",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:BR",
    name: "Brazil",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "IO",
    "alpha-3": "IOT",
    "country-code": "086",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:IO",
    name: "British Indian Ocean Territory",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "BN",
    "alpha-3": "BRN",
    "country-code": "096",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BN",
    name: "Brunei Darussalam",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "BG",
    "alpha-3": "BGR",
    "country-code": "100",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:BG",
    name: "Bulgaria",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "BF",
    "alpha-3": "BFA",
    "country-code": "854",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:BF",
    name: "Burkina Faso",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "BI",
    "alpha-3": "BDI",
    "country-code": "108",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:BI",
    name: "Burundi",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "CV",
    "alpha-3": "CPV",
    "country-code": "132",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:CV",
    name: "Cabo Verde",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "KH",
    "alpha-3": "KHM",
    "country-code": "116",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:KH",
    name: "Cambodia",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "CM",
    "alpha-3": "CMR",
    "country-code": "120",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:CM",
    name: "Cameroon",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "CA",
    "alpha-3": "CAN",
    "country-code": "124",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CA",
    name: "Canada",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Northern America",
    "sub-region-code": "021"
  },
  {
    "alpha-2": "KY",
    "alpha-3": "CYM",
    "country-code": "136",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:KY",
    name: "Cayman Islands",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "CF",
    "alpha-3": "CAF",
    "country-code": "140",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:CF",
    name: "Central African Republic",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "TD",
    "alpha-3": "TCD",
    "country-code": "148",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:TD",
    name: "Chad",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "CL",
    "alpha-3": "CHL",
    "country-code": "152",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:CL",
    name: "Chile",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "CN",
    "alpha-3": "CHN",
    "country-code": "156",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CN",
    name: "China",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "CX",
    "alpha-3": "CXR",
    "country-code": "162",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CX",
    name: "Christmas Island",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Australia and New Zealand",
    "sub-region-code": "053"
  },
  {
    "alpha-2": "CC",
    "alpha-3": "CCK",
    "country-code": "166",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CC",
    name: "Cocos (Keeling) Islands",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Australia and New Zealand",
    "sub-region-code": "053"
  },
  {
    "alpha-2": "CO",
    "alpha-3": "COL",
    "country-code": "170",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:CO",
    name: "Colombia",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "KM",
    "alpha-3": "COM",
    "country-code": "174",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:KM",
    name: "Comoros",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "CG",
    "alpha-3": "COG",
    "country-code": "178",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:CG",
    name: "Congo",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "CD",
    "alpha-3": "COD",
    "country-code": "180",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:CD",
    name: "Congo, Democratic Republic of the",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "CK",
    "alpha-3": "COK",
    "country-code": "184",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CK",
    name: "Cook Islands",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "CR",
    "alpha-3": "CRI",
    "country-code": "188",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:CR",
    name: "Costa Rica",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "CI",
    "alpha-3": "CIV",
    "country-code": "384",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:CI",
    name: "Côte d'Ivoire",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "HR",
    "alpha-3": "HRV",
    "country-code": "191",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:HR",
    name: "Croatia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "CU",
    "alpha-3": "CUB",
    "country-code": "192",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:CU",
    name: "Cuba",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "CW",
    "alpha-3": "CUW",
    "country-code": "531",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:CW",
    name: "Curaçao",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "CY",
    "alpha-3": "CYP",
    "country-code": "196",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CY",
    name: "Cyprus",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "CZ",
    "alpha-3": "CZE",
    "country-code": "203",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CZ",
    name: "Czechia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "DK",
    "alpha-3": "DNK",
    "country-code": "208",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:DK",
    name: "Denmark",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "DJ",
    "alpha-3": "DJI",
    "country-code": "262",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:DJ",
    name: "Djibouti",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "DM",
    "alpha-3": "DMA",
    "country-code": "212",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:DM",
    name: "Dominica",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "DO",
    "alpha-3": "DOM",
    "country-code": "214",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:DO",
    name: "Dominican Republic",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "EC",
    "alpha-3": "ECU",
    "country-code": "218",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:EC",
    name: "Ecuador",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "EG",
    "alpha-3": "EGY",
    "country-code": "818",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:EG",
    name: "Egypt",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Northern Africa",
    "sub-region-code": "015"
  },
  {
    "alpha-2": "SV",
    "alpha-3": "SLV",
    "country-code": "222",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:SV",
    name: "El Salvador",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "GQ",
    "alpha-3": "GNQ",
    "country-code": "226",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:GQ",
    name: "Equatorial Guinea",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "ER",
    "alpha-3": "ERI",
    "country-code": "232",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:ER",
    name: "Eritrea",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "EE",
    "alpha-3": "EST",
    "country-code": "233",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:EE",
    name: "Estonia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "SZ",
    "alpha-3": "SWZ",
    "country-code": "748",
    "intermediate-region": "Southern Africa",
    "intermediate-region-code": "018",
    "iso_3166-2": "ISO 3166-2:SZ",
    name: "Eswatini",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "ET",
    "alpha-3": "ETH",
    "country-code": "231",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:ET",
    name: "Ethiopia",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "FK",
    "alpha-3": "FLK",
    "country-code": "238",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:FK",
    name: "Falkland Islands (Malvinas)",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "FO",
    "alpha-3": "FRO",
    "country-code": "234",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:FO",
    name: "Faroe Islands",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "FJ",
    "alpha-3": "FJI",
    "country-code": "242",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:FJ",
    name: "Fiji",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Melanesia",
    "sub-region-code": "054"
  },
  {
    "alpha-2": "FI",
    "alpha-3": "FIN",
    "country-code": "246",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:FI",
    name: "Finland",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "FR",
    "alpha-3": "FRA",
    "country-code": "250",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:FR",
    name: "France",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "GF",
    "alpha-3": "GUF",
    "country-code": "254",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:GF",
    name: "French Guiana",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "PF",
    "alpha-3": "PYF",
    "country-code": "258",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PF",
    name: "French Polynesia",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "TF",
    "alpha-3": "ATF",
    "country-code": "260",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:TF",
    name: "French Southern Territories",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "GA",
    "alpha-3": "GAB",
    "country-code": "266",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:GA",
    name: "Gabon",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "GM",
    "alpha-3": "GMB",
    "country-code": "270",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:GM",
    name: "Gambia",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "GE",
    "alpha-3": "GEO",
    "country-code": "268",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:GE",
    name: "Georgia",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "DE",
    "alpha-3": "DEU",
    "country-code": "276",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:DE",
    name: "Germany",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "GH",
    "alpha-3": "GHA",
    "country-code": "288",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:GH",
    name: "Ghana",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "GI",
    "alpha-3": "GIB",
    "country-code": "292",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:GI",
    name: "Gibraltar",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "GR",
    "alpha-3": "GRC",
    "country-code": "300",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:GR",
    name: "Greece",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "GL",
    "alpha-3": "GRL",
    "country-code": "304",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:GL",
    name: "Greenland",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Northern America",
    "sub-region-code": "021"
  },
  {
    "alpha-2": "GD",
    "alpha-3": "GRD",
    "country-code": "308",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:GD",
    name: "Grenada",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "GP",
    "alpha-3": "GLP",
    "country-code": "312",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:GP",
    name: "Guadeloupe",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "GU",
    "alpha-3": "GUM",
    "country-code": "316",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:GU",
    name: "Guam",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "GT",
    "alpha-3": "GTM",
    "country-code": "320",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:GT",
    name: "Guatemala",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "GG",
    "alpha-3": "GGY",
    "country-code": "831",
    "intermediate-region": "Channel Islands",
    "intermediate-region-code": "830",
    "iso_3166-2": "ISO 3166-2:GG",
    name: "Guernsey",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "GN",
    "alpha-3": "GIN",
    "country-code": "324",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:GN",
    name: "Guinea",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "GW",
    "alpha-3": "GNB",
    "country-code": "624",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:GW",
    name: "Guinea-Bissau",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "GY",
    "alpha-3": "GUY",
    "country-code": "328",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:GY",
    name: "Guyana",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "HT",
    "alpha-3": "HTI",
    "country-code": "332",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:HT",
    name: "Haiti",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "HM",
    "alpha-3": "HMD",
    "country-code": "334",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:HM",
    name: "Heard Island and McDonald Islands",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Australia and New Zealand",
    "sub-region-code": "053"
  },
  {
    "alpha-2": "VA",
    "alpha-3": "VAT",
    "country-code": "336",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:VA",
    name: "Holy See",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "HN",
    "alpha-3": "HND",
    "country-code": "340",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:HN",
    name: "Honduras",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "HK",
    "alpha-3": "HKG",
    "country-code": "344",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:HK",
    name: "Hong Kong",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "HU",
    "alpha-3": "HUN",
    "country-code": "348",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:HU",
    name: "Hungary",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "IS",
    "alpha-3": "ISL",
    "country-code": "352",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IS",
    name: "Iceland",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "IN",
    "alpha-3": "IND",
    "country-code": "356",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IN",
    name: "India",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "ID",
    "alpha-3": "IDN",
    "country-code": "360",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:ID",
    name: "Indonesia",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "IR",
    "alpha-3": "IRN",
    "country-code": "364",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IR",
    name: "Iran (Islamic Republic of)",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "IQ",
    "alpha-3": "IRQ",
    "country-code": "368",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IQ",
    name: "Iraq",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "IE",
    "alpha-3": "IRL",
    "country-code": "372",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IE",
    name: "Ireland",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "IM",
    "alpha-3": "IMN",
    "country-code": "833",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IM",
    name: "Isle of Man",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "IL",
    "alpha-3": "ISR",
    "country-code": "376",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IL",
    name: "Israel",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "IT",
    "alpha-3": "ITA",
    "country-code": "380",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:IT",
    name: "Italy",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "JM",
    "alpha-3": "JAM",
    "country-code": "388",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:JM",
    name: "Jamaica",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "JP",
    "alpha-3": "JPN",
    "country-code": "392",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:JP",
    name: "Japan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "JE",
    "alpha-3": "JEY",
    "country-code": "832",
    "intermediate-region": "Channel Islands",
    "intermediate-region-code": "830",
    "iso_3166-2": "ISO 3166-2:JE",
    name: "Jersey",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "JO",
    "alpha-3": "JOR",
    "country-code": "400",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:JO",
    name: "Jordan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "KZ",
    "alpha-3": "KAZ",
    "country-code": "398",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:KZ",
    name: "Kazakhstan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Central Asia",
    "sub-region-code": "143"
  },
  {
    "alpha-2": "KE",
    "alpha-3": "KEN",
    "country-code": "404",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:KE",
    name: "Kenya",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "KI",
    "alpha-3": "KIR",
    "country-code": "296",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:KI",
    name: "Kiribati",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "KP",
    "alpha-3": "PRK",
    "country-code": "408",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:KP",
    name: "Korea (Democratic People's Republic of)",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "KR",
    "alpha-3": "KOR",
    "country-code": "410",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:KR",
    name: "Korea, Republic of",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "KW",
    "alpha-3": "KWT",
    "country-code": "414",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:KW",
    name: "Kuwait",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "KG",
    "alpha-3": "KGZ",
    "country-code": "417",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:KG",
    name: "Kyrgyzstan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Central Asia",
    "sub-region-code": "143"
  },
  {
    "alpha-2": "LA",
    "alpha-3": "LAO",
    "country-code": "418",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LA",
    name: "Lao People's Democratic Republic",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "LV",
    "alpha-3": "LVA",
    "country-code": "428",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LV",
    name: "Latvia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "LB",
    "alpha-3": "LBN",
    "country-code": "422",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LB",
    name: "Lebanon",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "LS",
    "alpha-3": "LSO",
    "country-code": "426",
    "intermediate-region": "Southern Africa",
    "intermediate-region-code": "018",
    "iso_3166-2": "ISO 3166-2:LS",
    name: "Lesotho",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "LR",
    "alpha-3": "LBR",
    "country-code": "430",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:LR",
    name: "Liberia",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "LY",
    "alpha-3": "LBY",
    "country-code": "434",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LY",
    name: "Libya",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Northern Africa",
    "sub-region-code": "015"
  },
  {
    "alpha-2": "LI",
    "alpha-3": "LIE",
    "country-code": "438",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LI",
    name: "Liechtenstein",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "LT",
    "alpha-3": "LTU",
    "country-code": "440",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LT",
    name: "Lithuania",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "LU",
    "alpha-3": "LUX",
    "country-code": "442",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LU",
    name: "Luxembourg",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "MO",
    "alpha-3": "MAC",
    "country-code": "446",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MO",
    name: "Macao",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "MG",
    "alpha-3": "MDG",
    "country-code": "450",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:MG",
    name: "Madagascar",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "MW",
    "alpha-3": "MWI",
    "country-code": "454",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:MW",
    name: "Malawi",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "MY",
    "alpha-3": "MYS",
    "country-code": "458",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MY",
    name: "Malaysia",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "MV",
    "alpha-3": "MDV",
    "country-code": "462",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MV",
    name: "Maldives",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "ML",
    "alpha-3": "MLI",
    "country-code": "466",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:ML",
    name: "Mali",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "MT",
    "alpha-3": "MLT",
    "country-code": "470",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MT",
    name: "Malta",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "MH",
    "alpha-3": "MHL",
    "country-code": "584",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MH",
    name: "Marshall Islands",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "MQ",
    "alpha-3": "MTQ",
    "country-code": "474",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:MQ",
    name: "Martinique",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "MR",
    "alpha-3": "MRT",
    "country-code": "478",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:MR",
    name: "Mauritania",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "MU",
    "alpha-3": "MUS",
    "country-code": "480",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:MU",
    name: "Mauritius",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "YT",
    "alpha-3": "MYT",
    "country-code": "175",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:YT",
    name: "Mayotte",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "MX",
    "alpha-3": "MEX",
    "country-code": "484",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:MX",
    name: "Mexico",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "FM",
    "alpha-3": "FSM",
    "country-code": "583",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:FM",
    name: "Micronesia (Federated States of)",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "MD",
    "alpha-3": "MDA",
    "country-code": "498",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MD",
    name: "Moldova, Republic of",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "MC",
    "alpha-3": "MCO",
    "country-code": "492",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MC",
    name: "Monaco",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "MN",
    "alpha-3": "MNG",
    "country-code": "496",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MN",
    name: "Mongolia",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "ME",
    "alpha-3": "MNE",
    "country-code": "499",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:ME",
    name: "Montenegro",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "MS",
    "alpha-3": "MSR",
    "country-code": "500",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:MS",
    name: "Montserrat",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "MA",
    "alpha-3": "MAR",
    "country-code": "504",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MA",
    name: "Morocco",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Northern Africa",
    "sub-region-code": "015"
  },
  {
    "alpha-2": "MZ",
    "alpha-3": "MOZ",
    "country-code": "508",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:MZ",
    name: "Mozambique",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "MM",
    "alpha-3": "MMR",
    "country-code": "104",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MM",
    name: "Myanmar",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "NA",
    "alpha-3": "NAM",
    "country-code": "516",
    "intermediate-region": "Southern Africa",
    "intermediate-region-code": "018",
    "iso_3166-2": "ISO 3166-2:NA",
    name: "Namibia",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "NR",
    "alpha-3": "NRU",
    "country-code": "520",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NR",
    name: "Nauru",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "NP",
    "alpha-3": "NPL",
    "country-code": "524",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NP",
    name: "Nepal",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "NL",
    "alpha-3": "NLD",
    "country-code": "528",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NL",
    name: "Netherlands",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "NC",
    "alpha-3": "NCL",
    "country-code": "540",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NC",
    name: "New Caledonia",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Melanesia",
    "sub-region-code": "054"
  },
  {
    "alpha-2": "NZ",
    "alpha-3": "NZL",
    "country-code": "554",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NZ",
    name: "New Zealand",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Australia and New Zealand",
    "sub-region-code": "053"
  },
  {
    "alpha-2": "NI",
    "alpha-3": "NIC",
    "country-code": "558",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:NI",
    name: "Nicaragua",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "NE",
    "alpha-3": "NER",
    "country-code": "562",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:NE",
    name: "Niger",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "NG",
    "alpha-3": "NGA",
    "country-code": "566",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:NG",
    name: "Nigeria",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "NU",
    "alpha-3": "NIU",
    "country-code": "570",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NU",
    name: "Niue",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "NF",
    "alpha-3": "NFK",
    "country-code": "574",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NF",
    name: "Norfolk Island",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Australia and New Zealand",
    "sub-region-code": "053"
  },
  {
    "alpha-2": "MK",
    "alpha-3": "MKD",
    "country-code": "807",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MK",
    name: "North Macedonia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "MP",
    "alpha-3": "MNP",
    "country-code": "580",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:MP",
    name: "Northern Mariana Islands",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "NO",
    "alpha-3": "NOR",
    "country-code": "578",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:NO",
    name: "Norway",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "OM",
    "alpha-3": "OMN",
    "country-code": "512",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:OM",
    name: "Oman",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "PK",
    "alpha-3": "PAK",
    "country-code": "586",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PK",
    name: "Pakistan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "PW",
    "alpha-3": "PLW",
    "country-code": "585",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PW",
    name: "Palau",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "PS",
    "alpha-3": "PSE",
    "country-code": "275",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PS",
    name: "Palestine, State of",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "PA",
    "alpha-3": "PAN",
    "country-code": "591",
    "intermediate-region": "Central America",
    "intermediate-region-code": "013",
    "iso_3166-2": "ISO 3166-2:PA",
    name: "Panama",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "PG",
    "alpha-3": "PNG",
    "country-code": "598",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PG",
    name: "Papua New Guinea",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Melanesia",
    "sub-region-code": "054"
  },
  {
    "alpha-2": "PY",
    "alpha-3": "PRY",
    "country-code": "600",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:PY",
    name: "Paraguay",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "PE",
    "alpha-3": "PER",
    "country-code": "604",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:PE",
    name: "Peru",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "PH",
    "alpha-3": "PHL",
    "country-code": "608",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PH",
    name: "Philippines",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "PN",
    "alpha-3": "PCN",
    "country-code": "612",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PN",
    name: "Pitcairn",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "PL",
    "alpha-3": "POL",
    "country-code": "616",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PL",
    name: "Poland",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "PT",
    "alpha-3": "PRT",
    "country-code": "620",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PT",
    name: "Portugal",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "PR",
    "alpha-3": "PRI",
    "country-code": "630",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:PR",
    name: "Puerto Rico",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "QA",
    "alpha-3": "QAT",
    "country-code": "634",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:QA",
    name: "Qatar",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "RE",
    "alpha-3": "REU",
    "country-code": "638",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:RE",
    name: "Réunion",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "RO",
    "alpha-3": "ROU",
    "country-code": "642",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:RO",
    name: "Romania",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "RU",
    "alpha-3": "RUS",
    "country-code": "643",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:RU",
    name: "Russian Federation",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "RW",
    "alpha-3": "RWA",
    "country-code": "646",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:RW",
    name: "Rwanda",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "BL",
    "alpha-3": "BLM",
    "country-code": "652",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:BL",
    name: "Saint Barthélemy",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "SH",
    "alpha-3": "SHN",
    "country-code": "654",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:SH",
    name: "Saint Helena, Ascension and Tristan da Cunha",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "KN",
    "alpha-3": "KNA",
    "country-code": "659",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:KN",
    name: "Saint Kitts and Nevis",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "LC",
    "alpha-3": "LCA",
    "country-code": "662",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:LC",
    name: "Saint Lucia",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "MF",
    "alpha-3": "MAF",
    "country-code": "663",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:MF",
    name: "Saint Martin (French part)",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "PM",
    "alpha-3": "SPM",
    "country-code": "666",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:PM",
    name: "Saint Pierre and Miquelon",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Northern America",
    "sub-region-code": "021"
  },
  {
    "alpha-2": "VC",
    "alpha-3": "VCT",
    "country-code": "670",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:VC",
    name: "Saint Vincent and the Grenadines",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "WS",
    "alpha-3": "WSM",
    "country-code": "882",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:WS",
    name: "Samoa",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "SM",
    "alpha-3": "SMR",
    "country-code": "674",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SM",
    name: "San Marino",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "ST",
    "alpha-3": "STP",
    "country-code": "678",
    "intermediate-region": "Middle Africa",
    "intermediate-region-code": "017",
    "iso_3166-2": "ISO 3166-2:ST",
    name: "Sao Tome and Principe",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "SA",
    "alpha-3": "SAU",
    "country-code": "682",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SA",
    name: "Saudi Arabia",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "SN",
    "alpha-3": "SEN",
    "country-code": "686",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:SN",
    name: "Senegal",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "RS",
    "alpha-3": "SRB",
    "country-code": "688",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:RS",
    name: "Serbia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "SC",
    "alpha-3": "SYC",
    "country-code": "690",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:SC",
    name: "Seychelles",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "SL",
    "alpha-3": "SLE",
    "country-code": "694",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:SL",
    name: "Sierra Leone",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "SG",
    "alpha-3": "SGP",
    "country-code": "702",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SG",
    name: "Singapore",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "SX",
    "alpha-3": "SXM",
    "country-code": "534",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:SX",
    name: "Sint Maarten (Dutch part)",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "SK",
    "alpha-3": "SVK",
    "country-code": "703",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SK",
    name: "Slovakia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "SI",
    "alpha-3": "SVN",
    "country-code": "705",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SI",
    name: "Slovenia",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "SB",
    "alpha-3": "SLB",
    "country-code": "090",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SB",
    name: "Solomon Islands",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Melanesia",
    "sub-region-code": "054"
  },
  {
    "alpha-2": "SO",
    "alpha-3": "SOM",
    "country-code": "706",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:SO",
    name: "Somalia",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "ZA",
    "alpha-3": "ZAF",
    "country-code": "710",
    "intermediate-region": "Southern Africa",
    "intermediate-region-code": "018",
    "iso_3166-2": "ISO 3166-2:ZA",
    name: "South Africa",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "GS",
    "alpha-3": "SGS",
    "country-code": "239",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:GS",
    name: "South Georgia and the South Sandwich Islands",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "SS",
    "alpha-3": "SSD",
    "country-code": "728",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:SS",
    name: "South Sudan",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "ES",
    "alpha-3": "ESP",
    "country-code": "724",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:ES",
    name: "Spain",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Southern Europe",
    "sub-region-code": "039"
  },
  {
    "alpha-2": "LK",
    "alpha-3": "LKA",
    "country-code": "144",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:LK",
    name: "Sri Lanka",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Southern Asia",
    "sub-region-code": "034"
  },
  {
    "alpha-2": "SD",
    "alpha-3": "SDN",
    "country-code": "729",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SD",
    name: "Sudan",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Northern Africa",
    "sub-region-code": "015"
  },
  {
    "alpha-2": "SR",
    "alpha-3": "SUR",
    "country-code": "740",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:SR",
    name: "Suriname",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "SJ",
    "alpha-3": "SJM",
    "country-code": "744",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SJ",
    name: "Svalbard and Jan Mayen",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "SE",
    "alpha-3": "SWE",
    "country-code": "752",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SE",
    name: "Sweden",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "CH",
    "alpha-3": "CHE",
    "country-code": "756",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:CH",
    name: "Switzerland",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Western Europe",
    "sub-region-code": "155"
  },
  {
    "alpha-2": "SY",
    "alpha-3": "SYR",
    "country-code": "760",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:SY",
    name: "Syrian Arab Republic",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "TW",
    "alpha-3": "TWN",
    "country-code": "158",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TW",
    name: "Taiwan, Province of China",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Eastern Asia",
    "sub-region-code": "030"
  },
  {
    "alpha-2": "TJ",
    "alpha-3": "TJK",
    "country-code": "762",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TJ",
    name: "Tajikistan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Central Asia",
    "sub-region-code": "143"
  },
  {
    "alpha-2": "TZ",
    "alpha-3": "TZA",
    "country-code": "834",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:TZ",
    name: "Tanzania, United Republic of",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "TH",
    "alpha-3": "THA",
    "country-code": "764",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TH",
    name: "Thailand",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "TL",
    "alpha-3": "TLS",
    "country-code": "626",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TL",
    name: "Timor-Leste",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "TG",
    "alpha-3": "TGO",
    "country-code": "768",
    "intermediate-region": "Western Africa",
    "intermediate-region-code": "011",
    "iso_3166-2": "ISO 3166-2:TG",
    name: "Togo",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "TK",
    "alpha-3": "TKL",
    "country-code": "772",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TK",
    name: "Tokelau",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "TO",
    "alpha-3": "TON",
    "country-code": "776",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TO",
    name: "Tonga",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "TT",
    "alpha-3": "TTO",
    "country-code": "780",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:TT",
    name: "Trinidad and Tobago",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "TN",
    "alpha-3": "TUN",
    "country-code": "788",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TN",
    name: "Tunisia",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Northern Africa",
    "sub-region-code": "015"
  },
  {
    "alpha-2": "TR",
    "alpha-3": "TUR",
    "country-code": "792",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TR",
    name: "Turkey",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "TM",
    "alpha-3": "TKM",
    "country-code": "795",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TM",
    name: "Turkmenistan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Central Asia",
    "sub-region-code": "143"
  },
  {
    "alpha-2": "TC",
    "alpha-3": "TCA",
    "country-code": "796",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:TC",
    name: "Turks and Caicos Islands",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "TV",
    "alpha-3": "TUV",
    "country-code": "798",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:TV",
    name: "Tuvalu",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "UG",
    "alpha-3": "UGA",
    "country-code": "800",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:UG",
    name: "Uganda",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "UA",
    "alpha-3": "UKR",
    "country-code": "804",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:UA",
    name: "Ukraine",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Eastern Europe",
    "sub-region-code": "151"
  },
  {
    "alpha-2": "AE",
    "alpha-3": "ARE",
    "country-code": "784",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:AE",
    name: "United Arab Emirates",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "GB",
    "alpha-3": "GBR",
    "country-code": "826",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:GB",
    name: "United Kingdom of Great Britain and Northern Ireland",
    region: "Europe",
    "region-code": "150",
    "sub-region": "Northern Europe",
    "sub-region-code": "154"
  },
  {
    "alpha-2": "US",
    "alpha-3": "USA",
    "country-code": "840",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:US",
    name: "United States of America",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Northern America",
    "sub-region-code": "021"
  },
  {
    "alpha-2": "UM",
    "alpha-3": "UMI",
    "country-code": "581",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:UM",
    name: "United States Minor Outlying Islands",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Micronesia",
    "sub-region-code": "057"
  },
  {
    "alpha-2": "UY",
    "alpha-3": "URY",
    "country-code": "858",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:UY",
    name: "Uruguay",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "UZ",
    "alpha-3": "UZB",
    "country-code": "860",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:UZ",
    name: "Uzbekistan",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Central Asia",
    "sub-region-code": "143"
  },
  {
    "alpha-2": "VU",
    "alpha-3": "VUT",
    "country-code": "548",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:VU",
    name: "Vanuatu",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Melanesia",
    "sub-region-code": "054"
  },
  {
    "alpha-2": "VE",
    "alpha-3": "VEN",
    "country-code": "862",
    "intermediate-region": "South America",
    "intermediate-region-code": "005",
    "iso_3166-2": "ISO 3166-2:VE",
    name: "Venezuela (Bolivarian Republic of)",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "VN",
    "alpha-3": "VNM",
    "country-code": "704",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:VN",
    name: "Viet Nam",
    region: "Asia",
    "region-code": "142",
    "sub-region": "South-eastern Asia",
    "sub-region-code": "035"
  },
  {
    "alpha-2": "VG",
    "alpha-3": "VGB",
    "country-code": "092",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:VG",
    name: "Virgin Islands (British)",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "VI",
    "alpha-3": "VIR",
    "country-code": "850",
    "intermediate-region": "Caribbean",
    "intermediate-region-code": "029",
    "iso_3166-2": "ISO 3166-2:VI",
    name: "Virgin Islands (U.S.)",
    region: "Americas",
    "region-code": "019",
    "sub-region": "Latin America and the Caribbean",
    "sub-region-code": "419"
  },
  {
    "alpha-2": "WF",
    "alpha-3": "WLF",
    "country-code": "876",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:WF",
    name: "Wallis and Futuna",
    region: "Oceania",
    "region-code": "009",
    "sub-region": "Polynesia",
    "sub-region-code": "061"
  },
  {
    "alpha-2": "EH",
    "alpha-3": "ESH",
    "country-code": "732",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:EH",
    name: "Western Sahara",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Northern Africa",
    "sub-region-code": "015"
  },
  {
    "alpha-2": "YE",
    "alpha-3": "YEM",
    "country-code": "887",
    "intermediate-region": "",
    "intermediate-region-code": "",
    "iso_3166-2": "ISO 3166-2:YE",
    name: "Yemen",
    region: "Asia",
    "region-code": "142",
    "sub-region": "Western Asia",
    "sub-region-code": "145"
  },
  {
    "alpha-2": "ZM",
    "alpha-3": "ZMB",
    "country-code": "894",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:ZM",
    name: "Zambia",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  },
  {
    "alpha-2": "ZW",
    "alpha-3": "ZWE",
    "country-code": "716",
    "intermediate-region": "Eastern Africa",
    "intermediate-region-code": "014",
    "iso_3166-2": "ISO 3166-2:ZW",
    name: "Zimbabwe",
    region: "Africa",
    "region-code": "002",
    "sub-region": "Sub-Saharan Africa",
    "sub-region-code": "202"
  }
], Om = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({ __proto__: null, default: Im }, Symbol.toStringTag, { value: "Module" }));
export {
  Mm as a,
  Cm as b,
  Bm as c,
  ym as e,
  Em as g,
  Om as i
};
//# sourceMappingURL=config-countries-df62edb9.js.map
